module.exports = __webpack_public_path__ + "img/summary_background_SZP_mobile_portrait.8d2f8f61.jpg";